import type { Deposit } from '@library/types/payments';
import { depositMethodDisplay } from '@library/component-utils/paymentsfilters';
import { getMethodInfoLines } from '@bo-utils/payments';

export const useDepositMethodInfo = () => {
  const getDepositMethodInfo = (deposit: Deposit) => {
    const { bank, card, method, paypal, venmo } = deposit;
    const methodInfo = getMethodInfoLines(
      method,
      depositMethodDisplay(method),
      card,
      bank,
      paypal,
      venmo
    );

    return methodInfo;
  };

  return {
    getDepositMethodInfo
  };
};
